import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-beneficiary-info',
  template: require('./primary-beneficiary-info.component.html')
})

export class PrimaryBeneficiaryInfoComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.marriedSelectedPrimary = this.flowManager.isMarried;

    this.primaryPercent = this.appActions.getData('BeneficiaryInformation.Primary[0].percent');
    if (!this.primaryPercent) {
      this.appActions.setData('BeneficiaryInformation.Primary[0].percent', 100);
      this.primaryPercent = 100;
    }

    const steps = this.flowManager.getStepArrays('primary-beneficiary-info');
    this.form.stepsComplete = steps.stepsComplete;
    this.form.stepsToComplete = steps.stepsToComplete;

    const lastStep = this.form.stepsComplete[this.form.stepsComplete.length - 1];
    this.form.buttons.inputs.back.path = `/${lastStep.route}`;
  }

  ngOnInit() {
    const percentObj = this.form.inputs.percent;
    percentObj.noneditable = this.flowManager.toPercent(this.primaryPercent);
  }

  updateOptionValue(event) {
    if (event.id === 'beneRelationship') {
      if (this.marriedSelectedPrimary === true && event.value !== 'Spouse') {
        this.form.inputs.spousalConsent.showUp = true;
        this.appActions.setData('BeneficiaryInformation.Primary[0].spousalConsent', true);
      } else {
        this.form.inputs.spousalConsent.showUp = false;
        this.appActions.setData('BeneficiaryInformation.Primary[0].spousalConsent', false);
      }
    }
  }
}
